import Content from 'modules/settings/components/Content'

const NavigateSettingsPage = () => {
  return <Content />
}

export default NavigateSettingsPage
